import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Context from '../context'
import './header.css'
import { ru } from "../data/ru"
import { by } from "../data/by"
import {AUTHORIZATION_URL, FEEDBACK_URL, INFORMATION_URL, PROFILE_URL, STATISTICS_URL, TESTS_URL} from "../../config";

const Header = () => {
    let language = localStorage.getItem('lang') === 'ru' ? ru.header : by.header
    const {mainState, changeLanguage, logOut} = useContext(Context)
    const [isOpen, setOpen] = useState(false);

    const close = () => setOpen(false);
    const changeToggleOpen = () => {
        setOpen(isOpen => !isOpen)
    }

    const styles = {
        open: {
            right: '0',
        },
        close: {
            right: '-100%',
        },
    }

    return (
        <header>
            <div className='header-item-left'>
                <div className='header-item-icon'>
                    {mainState.lang === 'ru' ?
                        <button className='button-language-change' onClick={() => changeLanguage('by')}>By</button> :
                        <button className='button-language-change' onClick={() => changeLanguage('ru')}>Ru</button>}
                </div>
            </div>
            <div className='header-item-right'>
                <div className='header-item-nav'>
                    <Link to={FEEDBACK_URL} className='header-item-link' onClick={close}>{language.feedback}</Link>
                </div>
            </div>
            <div className='header-item-right'>
                <div className='header-item-nav'>
                    {mainState.isLoggedIn ? <Link to={PROFILE_URL} className='header-item-link'
                                                  onClick={close}>{language.personalAccount}</Link> :
                        <Link to={AUTHORIZATION_URL} className='header-item-link'
                              onClick={close}>{language.singIn}</Link>}
                </div>
            </div>
            <div className='header-item-right'>
                <div className='header-item-icon'>
                    <div className="hamburger-menu">
                        <input onChange={changeToggleOpen} id="menu__toggle" type="checkbox" checked={isOpen}
                               width={200} height={100}/>
                        <label className="menu__btn" htmlFor="menu__toggle">
                            <span></span>
                        </label>

                        <ul onMouseLeave={close} style={isOpen ? styles.open : styles.close}
                            className="header-menu-try">
                            <li><Link className="menu__item" to='/' onClick={() => close()}>{language.menuMain}</Link>
                            </li>
                            <li><Link className="menu__item" to={INFORMATION_URL} onClick={() => close()}>{language.about}</Link>
                            </li>
                            {(mainState.isLoggedIn && (mainState.type === "Admin" || mainState.type === "Editor")) &&
                            <li><Link className="menu__item" to={TESTS_URL}
                                      onClick={() => close()}>{language.menuDemotests}</Link></li>}
                            {(mainState.isLoggedIn && (mainState.type === "Admin" || mainState.type === "Curator" || mainState.type === "Teacher")) &&
                                <li><Link className="menu__item" to={STATISTICS_URL}
                                          onClick={() => close()}>{language.menuStatistics}</Link></li>}
                            {mainState.isLoggedIn &&
                            <li><Link className="menu__item" to={AUTHORIZATION_URL} onClick={() => {
                                logOut();
                                close();
                            }}>{language.logOut}</Link></li>}
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header
